import React, { useState } from 'react';
import { auth } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Button, Card, Alert, Container } from 'react-bootstrap';

export default function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      setErr('');
      await createUserWithEmailAndPassword(auth, email, password);
      nav('/');                       // kayıt sonrası login
    } catch (e) {
      setErr(e.message);
    }
  };

  return (
    <Container className="d-flex justify-content-center mt-5">
      <Card style={{maxWidth:400, width:'100%'}}>
        <Card.Body>
          <h3 className="mb-4 text-center">Sign Up</h3>
          {err && <Alert variant="danger">{err}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" required value={email}
                            onChange={e=>setEmail(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" required value={password}
                            onChange={e=>setPassword(e.target.value)} />
            </Form.Group>
            <Button className="w-100" type="submit">Create Account</Button>
          </Form>
          <div className="text-center mt-3">
            Already have an account? <Link to="/login">Log In</Link>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
